module.exports = __webpack_public_path__ + "img/188.4e2dc91a.jpg";